import { render, staticRenderFns } from "./print-content.vue?vue&type=template&id=071b9894&scoped=true"
import script from "./print-content.vue?vue&type=script&lang=js"
export * from "./print-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071b9894",
  null
  
)

export default component.exports